
import { getParameterList, setParameterActive } from "@/service/parameter.service";
import { Parameter } from "@/types/parameter.type";
import { Pagination } from "@/types/pagination.type";
import { defineComponent } from "vue";
import { ElRowClassNameParams } from "@/types/element.type";
import PageHeaderComponent from "@/components/PageHeader.component.vue";
import ParameterForm from "@/components/parameter/parameterForm.component.vue";
import { Action, ElMessage, ElMessageBox } from "element-plus";
import { errorHandlerDefault } from "@/utils/handler.util";
import { Filter } from "@/types/filter.type";
import { debounce } from "lodash";

export default defineComponent({
  components: { PageHeaderComponent, ParameterForm },
  data() {
    return {
      parametersPagination: {} as Pagination<Parameter>,
      parameters: [] as Parameter[],
      parametersList: [] as Parameter[],
      currentPage: 1 as number,
      rowPerPage: 10 as number,
      totalRows: 0 as number,
      query: "" as string,
      showParameterForm: false,
      parameterSelected: undefined as Parameter | undefined,
    };
  },
  created() {
    this.search = debounce(this.refreshParameter, 300);
  },
  async mounted() {
    this.refreshParameter();
  },
  methods: {
    async refreshParameter(item: Parameter | undefined = undefined) {
      let index = -1;
      // TODO añadir parámetro filter en getParameter
      if (this.parametersList && item) {
        index = this.parametersList.findIndex((i) => i.id === item.id);
      }
      if (index !== -1 && item) {
        this.parametersList[index] = item;
      } else {
        const filter: Filter = {};
        if (this.query) {
          filter.multi = this.query;
        }
        this.parametersPagination = await getParameterList(
          this.currentPage,
          this.rowPerPage,
          filter
        );
        this.parametersList = this.parametersPagination.data;
        this.totalRows = this.parametersPagination.totalRows;
      }
    },
    confirmActivateItem(item: Parameter) {
      ElMessageBox.confirm(
        this.$t("confirm.activateParameter", { name: item.name }),
        this.$t("label.warning"),
        {
          confirmButtonText: this.$t("btn.accept"),
          cancelButtonText: this.$t("btn.cancel"),
          type: "warning",
          dangerouslyUseHTMLString: true,
          callback: (action: Action) => {
            if (action === "confirm") {
              this.changeStatusEntity(item, true);
            }
          },
        }
      );
    },
    confirmDeactivateItem(item: Parameter) {
      ElMessageBox.confirm(
        this.$t("confirm.deactivateParameter", { name: item.name }),
        this.$t("label.warning"),
        {
          confirmButtonText: this.$t("btn.accept"),
          cancelButtonText: this.$t("btn.cancel"),
          type: "warning",
          dangerouslyUseHTMLString: true,
          callback: (action: Action) => {
            if (action === "confirm") {
              this.changeStatusEntity(item, false);
            }
          },
        }
      );
    },

    /**
     * change status parameter
     * @param item
     * @param active
     */
    async changeStatusEntity(item: Parameter, active: boolean) {
      if (!item.id) {
        return;
      }
      await setParameterActive(item.id, active);
      ElMessage.success(this.$t("success.action"));

      // Refresh item
      this.refreshParameter();
    },

    openParameterFormDialog(item?: Parameter) {
      this.showParameterForm = true;
      this.parameterSelected = item;
    },
    closeParameterFormDialog() {
      this.showParameterForm = false;
      this.parameterSelected = undefined;
    },
    async saveParameter() {
      await (this.$refs["paramForm"] as InstanceType<typeof ParameterForm>)
        .doSave()
        .then(() => {
          this.refreshParameter();
          this.closeParameterFormDialog();
          ElMessage.success(this.$t("success.action"));
        })
        .catch(errorHandlerDefault);
    },
    tableRowClassName(params: ElRowClassNameParams<Parameter>): string {
      return params.row && params.row.active ? "" : "disable-row";
    },
    search(): void {
      this.refreshParameter();
    },
    /**
     * set page size
     * @param {number} size
     */
    changePaginationSize(size: number): void {
      this.rowPerPage = size;
      this.currentPage = 1;
      this.refreshParameter();
    },

    /**
     * change page
     * @param {number} page
     */
    changePaginationPage(page: number): void {
      this.currentPage = page;
      this.refreshParameter();
    },
  },
});
